import {
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
} from "@mui/material";
import React, { useState, useContext } from "react";
import Checkbox from "@mui/material/Checkbox";
import { variableContext } from "../context/VariableContex";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import Favorite from "@mui/icons-material/Favorite";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CallIcon from "@mui/icons-material/Call";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import LinkIcon from "@mui/icons-material/Link";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import { useHistory } from "react-router-dom";
import useBusinessQuery from "../store/Bussiness/useBusinessQuery";
import thumbnail from "../assets/thumbnail.png";
const label = { inputProps: { "aria-label": "Checkbox demo" } };

const ProductCard = ({ item, wideButtons, isPremiumSection, isHomeGrid }) => {
  const history = useHistory();
  const [copied, setCopied] = useState(false);
  const { layoutMode } = useContext(variableContext);
  // True only when this card is inside the desktop listing grid in Grid Mode.
  // wideButtons is the existing prop that CategoryDetails passes to mark
  // cards rendered inside .cat-details-grid.
  const isDesktopGrid = wideButtons && layoutMode === "grid";

  const handleCopyUrl = (e, url) => {
    e.preventDefault();
    e.stopPropagation();
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    } else {
      const ta = document.createElement('textarea');
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const local = JSON.parse(localStorage.getItem("user"));

  const { mutateAsync: addBookmark } = useBusinessQuery.Add_bookmark();

  const { data: bookmarkList } = useBusinessQuery.Get_bookmark_list(local?.id);

  const { mutateAsync: addCalls } = useBusinessQuery.Add_calls();

  const handleAddFavorite = async (e, id) => {
    if (local?.id) {
      try {
        await addBookmark(id);
      } catch (error) { }
    } else {
      alert("Please Login");
      return;
    }
  };

  const handleCalls = async () => {
    try {
      await addCalls({ business_id: parseInt(item.id) });
    } catch (error) { }
  };

  return (
    <Card
      sx={{
        minHeight: { xs: "112.7px", md: isHomeGrid ? "91.77px" : "92px" },
        // Desktop Grid Mode: remove the mx margins and apply exact 2mm width
        // reduction directly in the sx prop so MUI's own runtime style
        // injection carries the correct values — no external CSS override needed.
        mx: isDesktopGrid ? 0 : 0.2,
        mt: isDesktopGrid ? 0 : 2,
        width: isDesktopGrid ? "calc(100% - 2mm)" : undefined,
        position: "relative",
        transition: "transform 0.15s ease, box-shadow 0.15s ease",
        "&:active": {
          transform: "scale(0.98)",
          boxShadow: "0px 1px 3px rgba(0,0,0,0.15)",
        },
      }}
      className="product-card-root"
    >
      {/* Favorite icon — absolutely positioned on Card, fixed regardless of name length */}
      <Box
        sx={{
          position: "absolute",
          top: "calc(6px + 5mm)",
          right: "6px",
          width: "24px",
          height: "24px",
          border: "1px solid rgba(238, 238, 238, 1)",
          borderRadius: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1,
          backgroundColor: "rgba(255,255,255,0.85)",
        }}
      >
        <Checkbox
          {...label}
          checked={
            bookmarkList?.data?.results?.some(
              (value) => value.id === item.id
            )
              ? true
              : false
          }
          checkedIcon={
            <Favorite
              style={{
                color: "#ff0000",
                width: "15px",
                height: "15.65px",
              }}
            />
          }
          icon={
            <FavoriteBorder
              style={{
                color: "#2b2b2b",
                width: "15px",
                height: "15.65px",
              }}
            />
          }
          onChange={(e) => handleAddFavorite(e, item.id)}
          sx={{
            width: "24px",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        />
      </Box>

      <CardContent
        sx={{
          padding: "4px 12px !important",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          justifyContent: "space-evenly",
        }}
      >
        <Grid container spacing={1} sx={{ alignItems: "stretch" }}>
          <Grid item xs={5} className="product-card-left-panel">
            <div
              className="product-card-img-wrap"
              style={{ cursor: "pointer", width: "100%", height: "100%" }}
              onClick={() => history.push(`/product-details/${item.id}`)}
            >
              <Box
                sx={{
                  position: "relative",
                  width: { xs: "calc(119.95% - 3mm)", md: "calc(105.84% - 3mm)" },
                  height: { xs: "99.50px", md: isHomeGrid ? "83.58px" : "83.79px" },
                  borderRadius: "6px",
                  overflow: "hidden",
                  marginLeft: "-2mm",
                }}
              >
                <img
                  src={item.image ? item.image : thumbnail}
                  alt="not found"
                  width="100%"
                  style={{
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    boxShadow: "inset 0 0 8px 2px rgba(0, 0, 0, 0.35)",
                    pointerEvents: "none",
                  }}
                />
              </Box>
            </div>
          </Grid>
          <Grid item xs={7} sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
            {/* Row 1: Name only */}
            <Box className="pd-card-name-row" sx={{ display: "flex", alignItems: "flex-start", marginTop: { xs: "6mm", md: "1mm" }, position: "relative", top: isPremiumSection ? { xs: 0, md: "4mm" } : 0 }}>
              <Typography
                component="div"
                style={{ fontWeight: "600", lineHeight: "14px", flex: 1, cursor: "pointer", color: "#007F86", overflow: "visible", position: "relative", zIndex: 2 }}
                sx={{ fontSize: { xs: "12.6498px", sm: "12.6498px", md: "11.13px" }, paddingLeft: { xs: "2mm", md: 0 }, marginLeft: "-0.5mm" }}
                onClick={() => history.push(`/product-details/${item.id}`)}
              >
                {(() => {
                  const name = item.name || "";
                  const line1 = name.substring(0, 27);
                  const line2 = name.length > 27 ? name.substring(27) : null;
                  return (
                    <>
                      <div style={{ overflow: "hidden", whiteSpace: "nowrap", maxWidth: "100%" }}>{line1}</div>
                      {line2 && <div style={{ overflow: "hidden", whiteSpace: "nowrap", maxWidth: "100%" }}>{line2}</div>}
                    </>
                  );
                })()}
              </Typography>
            </Box>

            {/* Row 2: Location + badges */}
            <Box
              sx={{
                display: "flex",
                alignItems: isPremiumSection ? { xs: "center", md: "flex-end" } : "center",
                justifyContent: "space-between",
                marginTop: { xs: "3px", md: "0px" },
              }}
            >
              <Box className="pd-card-location" sx={{ display: "flex", alignItems: "center", gap: "3px", position: "relative", top: isPremiumSection ? { xs: 0, md: "1mm" } : 0 }}>
                <Typography style={{ fontSize: "10.8px", fontWeight: "500" }} sx={{ marginLeft: { xs: "2mm", md: "0mm" } }}>
                  {item.post_office || item.district_name || ''}
                </Typography>
              </Box>
              <Box className="pd-card-badges" sx={{ display: "flex", gap: "4px", flexShrink: 0, position: "relative", top: isPremiumSection ? { xs: "4mm", md: "5mm" } : "4mm", left: isPremiumSection ? { xs: 0, md: "2mm" } : 0 }}>
                {item.is_premium ? (
                  <Typography
                    className="badge-standard"
                    style={{
                      backgroundColor: "rgba(34, 139, 34, 1)",
                      minWidth: "40px",
                      height: "16px",
                      borderRadius: "4px",
                      color: "#fff",
                      fontSize: "7px",
                      fontWeight: "600",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "0 3px",
                    }}
                  >
                    Standard
                  </Typography>
                ) : null}
                {item.is_pro ? (
                  <Typography
                    className="badge-gold"
                    style={{
                      backgroundColor: "rgba(240, 150, 48, 1)",
                      minWidth: "32px",
                      height: "16px",
                      borderRadius: "4px",
                      color: "#fff",
                      fontSize: "7px",
                      fontWeight: "600",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "0 3px",
                    }}
                  >
                    Premium
                  </Typography>
                ) : null}
              </Box>
            </Box>

            {/* Row 2b: Website URL */}
            {item.website ? (
              <Box sx={{
                display: "flex",
                alignItems: "center",
                gap: "3px",
                marginTop: { xs: "3px", md: "2px" },
                minWidth: 0,
              }}>
                <LinkIcon style={{ fontSize: "10px", color: "#1565c0", flexShrink: 0 }} />
                <Typography
                  component="a"
                  href={item.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    fontSize: "9.5px",
                    fontWeight: "500",
                    color: "#1565c0",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    textDecoration: "none",
                    flex: 1,
                    minWidth: 0,
                    maxWidth: "calc(100% - 36px)",
                  }}
                >
                  {item.website.replace(/^https?:\/\/(www\.)?/, '')}
                </Typography>
                <Box
                  component="button"
                  onClick={(e) => handleCopyUrl(e, item.website)}
                  title={copied ? "Copied!" : "Copy link"}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "2px",
                    background: copied ? "#e8f5e9" : "#e3f2fd",
                    border: copied ? "1px solid #a5d6a7" : "1px solid #90caf9",
                    borderRadius: "4px",
                    padding: "1px 4px",
                    cursor: "pointer",
                    flexShrink: 0,
                    transition: "background 0.2s",
                    minWidth: "32px",
                    height: "16px",
                  }}
                >
                  {copied
                    ? <><CheckIcon style={{ fontSize: "9px", color: "#2e7d32" }} /><span style={{ fontSize: "8px", color: "#2e7d32", fontWeight: 600 }}>Copied</span></>
                    : <><ContentCopyIcon style={{ fontSize: "9px", color: "#1565c0" }} /><span style={{ fontSize: "8px", color: "#1565c0", fontWeight: 600 }}>Copy</span></>
                  }
                </Box>
              </Box>
            ) : null}

            {/* Row 3: Sub-category with tag icon */}
            {(item.sub_category_name || item.sub_category) ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: "3px", marginTop: { xs: "3px", md: "0px" } }}>
                <LocalOfferIcon style={{ fontSize: "10px", color: "rgba(100, 100, 100, 0.7)", flexShrink: 0 }} />
                <Typography
                  style={{
                    fontSize: "11px",
                    fontWeight: "500",
                    color: "rgba(100, 100, 100, 1)",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.sub_category_name || item.sub_category}
                </Typography>
              </Box>
            ) : null}

            <Box sx={{ width: "100%", marginLeft: { xs: "2mm", md: 0 } }}>
              {/* Desktop wide-button layout (wideButtons pages only) */}
              <Box sx={wideButtons ? {
                display: { xs: "none", md: "flex" },
                flexDirection: "row",
                gap: "1mm",
                paddingBottom: { xs: "4px", md: "1px" },
              } : { display: "none" }}>
                <Button
                  component="a"
                  href={`tel:${item.mobile_number}`}
                  onClick={handleCalls}
                  variant="contained"
                  className="btn-call"
                  style={{
                    fontSize: "10px",
                    borderRadius: "6px",
                    flex: 1,
                    textTransform: "none",
                    padding: "0",
                    height: "23.2px",
                    gap: "4px",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "transform 0.15s ease, filter 0.15s ease",
                  }}
                  sx={{
                    "& .MuiButton-startIcon": { margin: "0px" },
                    "&:active": { transform: "scale(0.95)", filter: "brightness(0.9)" },
                  }}
                  startIcon={<CallIcon style={{ fontSize: "10px" }} />}
                >
                  Call Now
                </Button>
                <Button
                  component="a"
                  href={`https://wa.me/91${item.whatsapp_number}?text=Hello`}
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="contained"
                  className="btn-whatsapp"
                  style={{
                    fontSize: "10px",
                    borderRadius: "6px",
                    flex: 1,
                    textTransform: "none",
                    padding: "0",
                    height: "23.2px",
                    gap: "4px",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "transform 0.15s ease, filter 0.15s ease",
                  }}
                  sx={{
                    "& .MuiButton-startIcon": { margin: "0px" },
                    "&:active": { transform: "scale(0.95)", filter: "brightness(0.9)" },
                  }}
                  startIcon={<WhatsAppIcon style={{ fontSize: "10px" }} />}
                >
                  Whatsapp
                </Button>
              </Box>
              {/* Standard Grid layout (all pages on mobile/tablet, non-wideButtons pages on desktop) */}
              <Grid container spacing={1} sx={{ paddingBottom: { xs: "4px", md: "1px" }, display: wideButtons ? { xs: "flex", md: "none" } : "flex" }}>
                <Grid item xs={6}>
                  <Button
                    component="a"
                    href={`tel:${item.mobile_number}`}
                    onClick={handleCalls}
                    variant="contained"
                    className="btn-call"
                    style={{
                      fontSize: "10px",
                      borderRadius: "6px",
                      width: "100%",
                      textTransform: "none",
                      padding: "0",
                      height: "23.2px",
                      gap: "4px",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "transform 0.15s ease, filter 0.15s ease",
                    }}
                    sx={{
                      "& .MuiButton-startIcon": { margin: "0px" },
                      "&:active": { transform: "scale(0.95)", filter: "brightness(0.9)" },
                    }}
                    startIcon={<CallIcon style={{ fontSize: "10px" }} />}
                  >
                    Call Now
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    component="a"
                    href={`https://wa.me/91${item.whatsapp_number}?text=Hello`}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    className="btn-whatsapp"
                    style={{
                      fontSize: "10px",
                      borderRadius: "6px",
                      width: "100%",
                      textTransform: "none",
                      padding: "0",
                      height: "23.2px",
                      gap: "4px",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "transform 0.15s ease, filter 0.15s ease",
                    }}
                    sx={{
                      "& .MuiButton-startIcon": { margin: "0px" },
                      "&:active": { transform: "scale(0.95)", filter: "brightness(0.9)" },
                    }}
                    startIcon={<WhatsAppIcon style={{ fontSize: "10px" }} />}
                  >
                    Whatsapp
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ProductCard;
